export default __webpack_public_path__ + "static/media/simonemoji.e76f9445.png";